import { ReferenceSystem } from './reference-system.enum';

export class BaseConfiguration {
  cutoff: number;
  displacementAndRotationNorm: boolean;
  maximumUnbalancedForce: boolean;
  forceAndMomentumNorm: boolean;
  maximumUnbalancedMoment: boolean;
  maxNumberOfIterations: number;
  maxUnbalancedForce: number;
  maxUnbalancedMoment: number;
  convergenceErrorTolerance: number;
  referenceSystem: ReferenceSystem;
}
